// @flow

import React, { Component } from 'react';
import styled from 'styled-components';
import { Swiper, Slide } from 'react-dynamic-swiper';

import arrow from '../arrow.svg';

const Root = styled.div`
  flex: 1;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Slider = styled.div`
  width: 270px;
  height: 270px;

  border-radius: 50%;
  overflow: hidden;

  background-color: #fff;
`;

const Picture = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const NavButton = styled.button`
  position: absolute;
  top: 50%;
  transform-origin: center center;
  transform: translateY(-50%);

  border: none;
  background: none;

  color: #fff;
  cursor: pointer;
  outline: none;
`;

const PrevButton = styled(NavButton)`
  left: 0;
`

const NextButton = styled(NavButton)`
  right: 0;
  transform: translateY(-50%) rotate(180deg);
`

const DotNav = styled.nav`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateY(300%);

  display: flex;
  justify-content: center;
`;

const Dot = styled.button`
  width: 9px;
  height: 9px;
  padding: 0;
  margin: 0 6px;

  border: 2px solid #fcfcfc;
  border-radius: 50%;

  background: ${props => props.active ? '#fcfcfc' : 'transparent'};
  cursor: ${props => props.active ? 'default' : 'pointer'};
  outline: none;
`

const StyledSwiper = styled(Swiper)`
  height: 270px;
`;

type PictureType = {
  url: string
}

type Props = {
  pictures: Array<PictureType>
}

type State = {
  selectedIndex: number,
}

class PictureSlider extends Component {
  state: State;
  props: Props;

  swiperInstance: Object;

  state = {
    selectedIndex: 0
  }

  componentDidMount() {
    this.swiperInstance.swiper().on('slideChangeStart', this.handleActiveSlide);
  }

  handleActiveSlide = (swiper: Object) => {
    const { realIndex } = swiper;

    this.setState({ selectedIndex: realIndex });
  }

  handlePrevButtonClick = () => {
    this.swiperInstance.swiper().slidePrev()
  }

  handleNextButtonClick = () => {
    this.swiperInstance.swiper().slideNext()
  }

  handleDotClick = (index: number) => {
    this.swiperInstance.swiper().slideTo(index)
  }

  render() {
    const { pictures } = this.props;
    const { selectedIndex } = this.state;

    return (
      <Root>
        <Slider>
          <StyledSwiper
            innerRef={(instance) => { this.swiperInstance = instance; }}
            swiperOptions={{
              slidesPerView: 1,
              preloadImages: false,
              lazyLoading: true,
              lazyLoadingInPrevNext: true,
              lazyLoadingInPrevNextAmount: 3,
            }}
            pagination={false}
            navigation={false}
          >
            {pictures.map((pic, index) => (
              <Slide key={index}>
                <Picture
                  data-src={pic.url}
                  alt={`Slide pic ${index + 1}`}
                  className="swiper-lazy"
                />
                <div className="swiper-lazy-preloader" />
              </Slide>
            ))}
          </StyledSwiper>
        </Slider>

        <DotNav>
          {pictures.map((pic, index) => (
            <Dot
              key={index}
              active={selectedIndex === index}
              onClick={() => this.handleDotClick(index)}
            />
          ))}
        </DotNav>

        <PrevButton
          onClick={this.handlePrevButtonClick}
        >
          <img
            src={arrow}
            width="22"
            height="42"
            alt="Go back"
          />
        </PrevButton>
        <NextButton
          onClick={this.handleNextButtonClick}
        >
          <img
            src={arrow}
            width="22"
            height="42"
            alt="Go forward"
          />
        </NextButton>
      </Root>
    )
  }
}

export default PictureSlider;



// WEBPACK FOOTER //
// ./src/components/ProductDrawer/PictureSlider.js